import React, { useEffect, useState } from 'react';
import { useApp } from '@k3/core';
import {
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
} from '@mui/material';
import { useDealer } from '../../hooks/useDealer';
import { useUrls } from '../../hooks/useUrls';
import { storageUtils } from '../../lib/CookieHelper';
import { useIsKioskMode } from '../../hooks/useIsKioskMode';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import { formatGermanPhoneNumberForTel } from '../../lib/StringHelper';

const AccessibilityDialog = (): React.JSX.Element => {
  const [open, setOpen] = useState(false);
  const [checked, setChecked] = useState(false);

  const app = useApp();
  const appCode = app.code;
  const dealer = useDealer();
  const dealerUrls = useUrls();
  const kiosk = useIsKioskMode();

  if (!dealerUrls?.hotline || kiosk) {
    return <></>;
  }

  const handleClose = () => {
    if (checked) {
      const cookiename = `${dealer}_${appCode}_accessibility_dialog`;
      const isHttps = window.location.protocol === 'https:';
      storageUtils.setValue(cookiename, true, 'cookie', {
        secure: isHttps,
        sameSite: 'none',
      });
    }
    setOpen(false);
  };

  useEffect(() => {
    const cookiename = `${dealer}_${appCode}_accessibility_dialog`;
    const shouldShown =
      (storageUtils.getValue(cookiename, 'cookie') as boolean) ?? false;
    setOpen(!shouldShown);
  }, []);

  return (
    <Dialog open={open}>
      <DialogTitle id="alert-dialog-title">Sie benötigen Hilfe?</DialogTitle>
      <DialogContent id="alert-dialog-description">
        <DialogContentText
          style={{ textAlign: 'center', paddingBottom: '2rem' }}
        >
          Unser Service übernimmt auf Wunsch die Konfiguration für Dich oder
          unterstützt telefonisch bei den einzelnen Schritten.
        </DialogContentText>
        <DialogContentText style={{ textAlign: 'center' }}>
          <strong>Unsere kostenfreie Telefonhotline:</strong>
          <span
            style={{
              textAlign: 'center',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'row',
              gap: '0.5rem',
              padding: '1rem 0',
            }}
          >
            <LocalPhoneIcon style={{ height: '1rem', width: '1rem' }} />
            <a href={`${formatGermanPhoneNumberForTel(dealerUrls.hotline)}`}>
              {dealerUrls.hotline}
            </a>
          </span>
          <span style={{ textAlign: 'center' }}>
            Mo.–Fr. 8:00–19:00 Uhr &amp; Sa. 9:00–17:30 Uhr
          </span>
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          paddingLeft: '1.5rem',
          paddingRight: '1.5rem',
        }}
      >
        <FormControlLabel
          sx={{
            marginRight: 'auto',
          }}
          control={
            <Checkbox
              checked={checked}
              onChange={(e) => setChecked(e.target.checked)}
            />
          }
          label="Diesen Dialog nicht mehr anzeigen"
        />
        <Button variant="contained" onClick={handleClose}>
          Okay
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { AccessibilityDialog };
